import { useEffect, useState } from "react";
import api from "../lib/api";
import MovieCard from "../components/MovieCard";
import MovieDetailModal from "../components/MovieDetailModal";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q) { setResults([]); return; }
    let cancelled = false;
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/movies?q=${encodeURIComponent(q)}`);
        if (!cancelled) setResults(data);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, 300);
    return () => { cancelled = true; clearTimeout(t); };
  }, [q]);

  return (
    <div className="min-h-screen bg-[#050505] pt-32 pb-24" data-testid="search-page">
      <div className="px-6 md:px-12 max-w-[1500px] mx-auto">
        <span className="text-xs uppercase tracking-[0.3em] text-[#D9381E]">Find a film</span>
        <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter text-white mt-3">
          Search
        </h1>

        <div className="relative mt-10 max-w-2xl">
          <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-[#8A8A8A]" size={18} strokeWidth={1.5} />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            autoFocus
            placeholder="Title, director, or cast…"
            className="w-full bg-[#0F0F0F] border border-[#222] focus:border-[#D9381E] focus:outline-none text-white pl-12 pr-4 py-4 transition-colors"
            data-testid="search-input"
          />
        </div>

        <div className="mt-10">
          {loading && <p className="text-[#8A8A8A] text-sm">Searching…</p>}
          {!loading && q && results.length === 0 && (
            <p className="text-[#8A8A8A] text-sm" data-testid="search-no-results">
              No films match "{q}". Submit a request to add it.
            </p>
          )}
          {results.length > 0 && (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
              {results.map((m) => (
                <MovieCard key={m.id} movie={m} onClick={setSelected} />
              ))}
            </div>
          )}
        </div>
      </div>
      <MovieDetailModal movie={selected} open={!!selected} onClose={() => setSelected(null)} />
    </div>
  );
}
